<aside class="market-notice" role="note" aria-label="Пояснение за пазарните цени">
  <svg class="notice-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="10" cy="10" r="10" class="icon-circle" />
    <circle cx="10" cy="5.8" r="1.2" class="icon-mark" />
    <rect x="8.8" y="9" width="2.4" height="6" rx="1.2" class="icon-mark" />
  </svg>
  <div class="content">
    <span class="highlight">Офертни пазарни цени:</span>
    <span class="desc">
      {{ text() || 'Показаните цени са офертни (обявени от продавачите в порталите), а не на реално изповядани сделки в Агенция по вписванията.' }}
    </span>
  </div>
</aside>
